<script>
    import { onMount, onDestroy } from 'svelte';
    import { shouldPrompt, snoozePrompt, subscribeNow, pushTrigger, pushOpen, webPushEnabled } from '../../push';

    let show = false;
    let working = false;
    let appName = 'แอปพลิเคชัน';
    let logo = '';
    let popupTitle = '';   // หัวข้อที่ตั้งจาก bo (ว่าง = ใช้ค่าเริ่มต้น)
    let popupText = '';    // ข้อความที่ตั้งจาก bo (ว่าง = ใช้ค่าเริ่มต้น)
    let popupImage = '';   // รูปที่ตั้งจาก bo (ว่าง = ใช้โลโก้)
    let timer;

    function loadInfo() {
        try {
            const s = JSON.parse(window.localStorage.getItem('setting') || '{}');
            appName = s.title || appName;
            logo = s.logo || s.logo_wallet || '';
            const p = (s && s.push) ? s.push : {};
            popupTitle = p.popup_title || '';
            popupText = p.popup_text || '';
            popupImage = p.popup_image || '';
        } catch (e) { /* noop */ }
    }

    // เด้งอัตโนมัติเมื่อ login + ยังไม่เคยตัดสินใจ + ไม่ติด snooze
    function maybeShow(delay) {
        clearTimeout(timer);
        timer = setTimeout(() => { if (shouldPrompt()) { loadInfo(); show = true; } }, delay);
    }

    // กดปุ่ม "แจ้งเตือน" ในแถบ footer → บังคับเด้ง popup (ข้าม snooze เพราะ user กดเอง)
    function openNow() {
        if (!webPushEnabled()) return;   // เว็บปิด push ไว้ = ไม่เด้ง popup เด็ดขาด
        loadInfo();
        show = true;
    }

    onMount(() => { loadInfo(); maybeShow(1800); });

    // เด้งหลังกด "เข้าสู่ระบบ" สำเร็จ (Auth → triggerPush) — store ส่งค่าเริ่ม 0 จึง guard n>0
    const unsubT = pushTrigger.subscribe((n) => { if (n > 0) maybeShow(1200); });
    // กดปุ่มในแถบ footer (Footer → openPushPopup)
    const unsubO = pushOpen.subscribe((n) => { if (n > 0) openNow(); });
    onDestroy(() => { unsubT(); unsubO(); clearTimeout(timer); });

    async function accept() {
        if (working) return;
        working = true;
        await subscribeNow();   // ขอ permission จริงของ browser ตรงนี้ (เป็น user gesture)
        working = false;
        show = false;
    }

    function later() {
        snoozePrompt();
        show = false;
    }
</script>

{#if show}
<div class="pp-overlay" on:click|self={later}>
    <div class="pp-card">
        <div class="pp-bell">
            {#if popupImage || logo}
                <img src={popupImage || logo} alt={appName} />
            {:else}
                <span class="pp-bell-emoji">🔔</span>
            {/if}
        </div>
        <h3 class="pp-title">{popupTitle || ('เปิดการแจ้งเตือนจาก ' + appName)}</h3>
        {#if popupText}
            <p class="pp-desc pp-desc-custom">{popupText}</p>
        {:else}
            <p class="pp-desc">
                รับข่าวสาร โปรโมชั่น และสิทธิพิเศษล่าสุดก่อนใคร<br />
                ผ่านการแจ้งเตือนถึงหน้าจอของคุณโดยตรง
            </p>
        {/if}
        <div class="pp-actions">
            <button class="pp-btn pp-later" on:click={later} disabled={working}>ไว้ก่อน</button>
            <button class="pp-btn pp-accept" on:click={accept} disabled={working}>
                {#if working}กำลังเปิด...{:else}ยอมรับ{/if}
            </button>
        </div>
    </div>
</div>
{/if}

<style>
    .pp-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, .6);
        backdrop-filter: blur(3px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99999;
        padding: 24px;
        animation: pp-fade .2s ease;
    }
    .pp-card {
        width: 100%;
        max-width: 340px;
        background: linear-gradient(160deg, #1f1f1f 0%, #141414 100%);
        border: 1px solid rgba(230, 196, 119, .45);
        border-radius: 18px;
        padding: 26px 22px 20px;
        text-align: center;
        color: #fff;
        box-shadow: 0 12px 40px rgba(0, 0, 0, .6);
        animation: pp-pop .25s cubic-bezier(.18, .89, .32, 1.28);
    }
    .pp-bell {
        width: 72px;
        height: 72px;
        margin: 0 auto 14px;
        border-radius: 50%;
        background: radial-gradient(circle at 50% 35%, rgba(230, 196, 119, .25), rgba(230, 196, 119, .05));
        border: 1px solid rgba(230, 196, 119, .4);
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    .pp-bell img { max-width: 100%; max-height: 100%; object-fit: cover; }
    .pp-bell-emoji { font-size: 2rem; }
    .pp-title {
        color: #e6c477;
        font-weight: 600;
        font-size: 1.05rem;
        margin: 0 0 8px;
    }
    .pp-desc {
        font-size: .82rem;
        line-height: 1.65;
        color: #d7d7d7;
        margin: 0 0 20px;
    }
    .pp-desc-custom { white-space: pre-line; }
    .pp-actions { display: flex; gap: 10px; }
    .pp-btn {
        flex: 1;
        padding: 11px 0;
        border-radius: 10px;
        font-weight: 600;
        font-size: .9rem;
        cursor: pointer;
        transition: opacity .15s, transform .1s;
    }
    .pp-btn:disabled { opacity: .6; cursor: default; }
    .pp-btn:active { transform: scale(.97); }
    .pp-later {
        background: transparent;
        border: 1px solid rgba(255, 255, 255, .25);
        color: #cfcfcf;
    }
    .pp-accept {
        border: none;
        color: #1a1a1a;
        background: linear-gradient(135deg, #e6c477 0%, #f4e2b8 50%, #e6c477 100%);
        box-shadow: 0 3px 10px rgba(230, 196, 119, .35);
    }
    @keyframes pp-fade { from { opacity: 0; } to { opacity: 1; } }
    @keyframes pp-pop { from { opacity: 0; transform: translateY(12px) scale(.96); } to { opacity: 1; transform: none; } }
</style>
